export const Footer = () => {
  return (<div className="footer">Copyright {new Date().getFullYear()} Paul Wilhelm-Aronofsky</div>)
}